/** Shared list query params for sortable agent tables (future API query string contract). */
export interface EventqSortParams {
  column?: string;
  direction?: 'asc' | 'desc';
}

export const EVENTQ_SORT_QUERY_KEYS = {
  column: 'sortColumn',
  direction: 'sortDirection',
} as const;
